<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">
        意向发布项目登记
        <a-button type="primary" icon="plus" style="float: right; margin-left: 10px;">新建项目</a-button>
        <a-button type="default" icon="copy" style="float: right;">复制项目</a-button>
      </div>

      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="项目状态">
            <a-select default-value="全部" style="width: 160px">
              <a-select-option value="all">全部</a-select-option>
              <a-select-option value="auditing">审核中</a-select-option>
              <a-select-option value="approved">已通过</a-select-option>
              <a-select-option value="rejected">未通过</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="项目名称">
            <a-input-search placeholder="请输入项目名称" style="width: 250px" />
          </a-form-item>

          <a-button type="primary" style="margin-top: 4px;">查询</a-button>
          <a-button style="margin-left: 10px;">重置</a-button>
        </a-form>
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        rowKey="id"
        :pagination="{ pageSize: 10, total: data.length }"
        :scroll="{ x: 1500 }"
        locale="{ emptyText: '暂无数据' }"
      >
        <template slot="operation">
          <a style="color: #1890ff;">查看</a>
        </template>
      </a-table>
    </a-card>
  </div>
</template>


<script>
export default {
  data() {
    return {
      columns: [
        { title: '序号', dataIndex: 'index', width: 80, key: 'index' },
        { title: '项目名称', dataIndex: 'name', width: 250, key: 'name' },
        { title: '项目编号', dataIndex: 'code', width: 180, key: 'code' },
        { title: '计租数量(租赁面积)', dataIndex: 'area', width: 200, key: 'area' },
        { title: '审核状态', dataIndex: 'status', width: 100, key: 'status' },
        { title: '提交时间', dataIndex: 'submitTime', width: 180, key: 'submitTime' },
        { title: '拟意向开始日期', dataIndex: 'intentStart', width: 150, key: 'intentStart' },
        { title: '拟意向结束日期', dataIndex: 'intentEnd', width: 150, key: 'intentEnd' },
        { title: '实际截止日期', dataIndex: 'realDeadline', width: 150, key: 'realDeadline' },
        { title: '操作', key: 'operation', fixed: 'right', width: 120, scopedSlots: { customRender: 'operation' } },
      ],
      data: [] // 当前无数据
    };
  },
};

</script>

<style scoped>
.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input{
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}
</style>